module.exports = __webpack_public_path__ + "img/play_gif_audio.c3113cde.gif";